import type { QueryKey } from '@tanstack/react-query';
import { partialMatchKey } from '@tanstack/react-query';

//* 생성 키는 [{ _id, baseUrl, ... }] 객체라 includes 참조 비교로는 새로 만든 키가 절대 일치하지 않는다
export const matchesAnyQueryKey = (
  queryKey: QueryKey,
  targetKeys: Array<QueryKey>,
) => targetKeys.some((targetKey) => partialMatchKey(queryKey, targetKey));
